import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { CustomSortService } from '@commoncore/services/custom-sort.service';
import { ActiveRepo } from '@commoncore/services/universal.service';
import { JustifiedView } from '@commoncore/utils/JustifiedViewUtil';
import { MultiSelectLibrary } from '@commoncore/utils/MultiSelectUtil';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { IndexedDBModule } from '@mainrepo/app/core/database/IndexedDBManager';
import { LocalStorageSvc } from '../services/localStorage.service';
import { FoldersViewImplementation } from './FoldersViewImplementation';
import { ListViewImplementation } from './ListViewImplementation';
export class AllFilesImplementation {

    public router: any;
    public http: any;
    public route:any;
    public universalService:any;
    public globalService:any;
    public allFilesnextLink = "";
    public allFilespreviousLink = "";
    public sortOrder:any;
    public flag:boolean = false;
    public rootFolderCheck:boolean = false;
    public docheignt:number=0;
    public toppos:number=0; 
    public customMetadata:any;
    public JsView:JustifiedView;
    public customSort:any;
    public multiSelect:any;
    public listService:any;
    public contextMenuService: any;
    listImpl:any;
    allfileslistsize = 0;
    foldersController: any;
    foldersViewImpl: any;
    localStorageSvc:LocalStorageSvc;
    loggerService: any;
    refetchData:boolean=false;
    db: IndexedDBModule;
    indexDBData:any=""
    readonly deskFoldersCount : number = 12;
  containerHeightCalc: any;
  static singleInstance:any = null;
  public currentPageNo = 0;
  public previousPageNo = -1;
  paginationService: any;
  public resizeableObjectList = []; // it is used only for resize window frame - do not overwrite or use.
  sessionStorageSvc: any;
    
    constructor(globalService) {
      this.globalService=globalService;
      
      this.localStorageSvc = globalService.getLocalStorageSvcRef();
      this.setHandler(globalService)
    }

    public setHandler(globalService){
      this.universalService=globalService.getUniversalServiceRef();
      this.router = globalService.getRouterRef();
      this.http=globalService.getHttpClientRef();
      this.route = globalService.getActivatedRoute();
      this.listService = globalService.getListServiceRef();
      this.listImpl = ListViewImplementation.getInstance(globalService)
      this.foldersViewImpl = FoldersViewImplementation.getInstance(this.globalService);
      this.JsView = new JustifiedView(this.universalService);
      this.customMetadata = globalService.getCustomMetadataServiceRef();
      this.customSort = new CustomSortService(this.universalService);
      this.contextMenuService = globalService.getContextMenuServiceRef();
      this.multiSelect = MultiSelectLibrary.getInstance(globalService);
      this.allFilesnextLink = this.universalService.allFilesnextLink;
      this.loggerService = globalService.getLoggerServiceRef();
      this.db = IndexedDBModule.getInstance(globalService);
      this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
      this.paginationService = globalService.getPaginationServiceRef();
      this.sessionStorageSvc = this.globalService.getSessionStorageSvcRef();
    }

    public static getInstance(globalService):AllFilesImplementation{
      if(this.singleInstance == null){
        this.singleInstance = new AllFilesImplementation(globalService);
        return this.singleInstance;
      }else{
        return this.singleInstance;
      }
      }

    decideSortOrder(url){
        this.allFilesnextLink = "";
        this.allFilespreviousLink = "";
        this.currentPageNo = 0;
        this.previousPageNo = -1;
        this.paginationService.LOCAL_DB = {}
        this.universalService.mobileSelectedObj = [];
        let sortingType = this.universalService.sharePublicSortSetting();
        this.sessionStorageSvc.setSharePublicSortPropName(sortingType);
        this.universalService.objectsPreviewArray = [];
        this.allfileslistsize = 0;
        this.universalService.scrollToTopIcon = false;
        this.universalService.shareViewTypeSetting();

        
        if(!this.universalService.listView || (this.universalService.listView && this.universalService.isMobileDevice)) {
            if (localStorage.sharePublicSort == this.universalService.sharePublicSortByDate) {
              this.universalService.nameSort = false;
              if(url.includes("type=w")){
                let sortingOrder = localStorage.sharePublicSort;
                sortingOrder = sortingOrder.replace("createdDate","fileCreatedDate");
                this.sortOrder='&sort='+sortingOrder;
              }else{
                this.sortOrder='&sort='+localStorage.sharePublicSort;
              }
            } else {
              this.universalService.nameSort = true;
              this.sortOrder='&sort='+localStorage.sharePublicSort;
            }
          }else{
            this.sortOrder = this.listService.listViewSortOrder;
            localStorage.setItem('listViewSortOrder',this.listService.listViewSortOrder);
          }
          return url   = url + this.sortOrder;
          
    
      }

  getIndexDBStoreName(url) {

    if (url.includes("type=w") && url.includes("sort=%2BobjectName")) {
      return "AllFiles_FolderMetadata_Name_Asc"
    } else if (url.includes("type=w") && url.includes("sort=%2DfileCreatedDate")) {
      return "AllFiles_FolderMetadata_Date_Desc";
    } else if (url.includes("type=f") && url.includes("sort=%2BobjectName")) {
      return "AllFilesMetadata_Grid_Name_Asc";
    } else if (url.includes("type=f") && url.includes("sort=%2DfileCreatedDate")) {
      return "AllFilesMetadata_Grid_Date_Desc";
    } 
    
    /*
    else if (url.includes("sort=%2DfileCreatedDate")) {
      return "AllFilesMetadata_List_Date_Desc";
    } else if (url.includes("sort=%2BfileCreatedDate")) {
      return "AllFilesMetadata_List_Date_Asc";
    } else if (url.includes("sort=%2DobjectName")) {
      return "AllFilesMetadata_List_Name_Desc";
    } else if (url.includes("sort=%2BobjectName")) {
      return "AllFilesMetadata_List_Name_Asc";
    } else if (url.includes("sort=%2DsizeInBytes")) {
      return "AllFilesMetadata_List_Size_Desc";
    } else if (url.includes("sort=%2BsizeInBytes")) {
      return "AllFilesMetadata_List_Size_Asc";
    } else if (url.includes("sort=%2DmimeType")) {
      return "AllFilesMetadata_List_Type_Desc";
    } else if (url.includes("sort=%2BmimeType")) {
      return "AllFilesMetadata_List_Type_Asc";
    }*/

    else if (url.includes("type=w") && url.includes("sort=%2DobjectName")) {
      return "AllFiles_FolderMetadata_Name_Desc"
    } else if (url.includes("type=w") && url.includes("sort=%2BfileCreatedDate")) {
      return "AllFiles_FolderMetadata_Date_Asc";
    }else if (url.includes("type=w") && url.includes("sort=%2BcreatedDate")) {
      return "AllFiles_FolderMetadata_Date_Asc";//"AllFiles_FolderMetadata_UploadDate_Asc"
    } else if (url.includes("type=w") && url.includes("sort=%2DcreatedDate")) {
      return "AllFiles_FolderMetadata_Date_Desc";//"AllFiles_FolderMetadata_UploadDate_Desc";
    } else if (url.includes("type=f") && url.includes("sort=%2DobjectName")) {
      return "AllFilesMetadata_Grid_Name_Desc";
    } else if (url.includes("type=f") && url.includes("sort=%2BfileCreatedDate")) {
      return "AllFilesMetadata_Grid_Date_Asc";
    }else if (url.includes("type=f") && url.includes("sort=%2BcreatedDate")) {
      return "AllFilesMetadata_Grid_CreatedDate_Asc";
    }else if (url.includes("type=f") && url.includes("sort=%2DcreatedDate")) {
      return "AllFilesMetadata_Grid_CreatedDate_Desc";
    }


  }

  async checkDataIndexDB(url) {
    let storeName = this.getIndexDBStoreName(url);
    var result = await this.db.getAllData(storeName,"AllFilesImplementation");

    if (url.includes("type=w") && url.includes("sort=%2BobjectName")) {
      this.universalService.currentOpenIndexDBStoreforFolder =  "AllFiles_FolderMetadata_Name_Asc";
    } else if (url.includes("type=w") && url.includes("sort=%2DfileCreatedDate")) {
      this.universalService.currentOpenIndexDBStoreforFolder =  "AllFiles_FolderMetadata_Date_Desc";
    }else if (url.includes("type=w") && url.includes("sort=%2DobjectName")) {
      this.universalService.currentOpenIndexDBStoreforFolder =  "AllFiles_FolderMetadata_Name_Desc";
    } else if (url.includes("type=w") && url.includes("sort=%2BfileCreatedDate")) {
      this.universalService.currentOpenIndexDBStoreforFolder =  "AllFiles_FolderMetadata_Date_Asc";
    }else if (url.includes("type=w") && url.includes("sort=%2BcreatedDate")) {
      this.universalService.currentOpenIndexDBStoreforFolder =  "AllFiles_FolderMetadata_CreatedDate_Asc";
    } else if (url.includes("type=w") && url.includes("sort=%2DcreatedDate")) {
      this.universalService.currentOpenIndexDBStoreforFolder =  "AllFiles_FolderMetadata_CreatedDate_Desc";
    }else{
      if(storeName!=undefined && storeName.includes("_List_"))
        this.universalService.currentOpenIndexDBStoreforFolder =  storeName;

      this.universalService.currentOpenIndexDBStoreforFile = storeName
    }

    if (result) {
       var suc = {
        "objects": result
      };
      //if (!url.includes("type=w") ) {
        var nextData = await this.db.getByKey('NextLink', storeName);
        if (nextData != undefined && nextData['nextLink']) {
          suc['nextLink'] = nextData['nextLink'];
        }
      //}

      return suc;
    }
    return false;
  }

      saveToIndexDB(url, suc) {
        var storeName = this.getIndexDBStoreName(url);
        this.db.bulkAdd(storeName, suc['objects']);
    
        //if(!url.includes("type=w") && suc['nextLink']) {
        if(suc['nextLink']) {
          var nextLinkObj = {
            'storeName': storeName,
            'nextLink': suc['nextLink']
          };
          this.db.update('NextLink', nextLinkObj);
        //} else if(!url.includes("type=w")) {
        } else {
           this.db.deleteByKey("NextLink",storeName);
        }
      }

     
      async getAllFilesAndFoldersData(url){
        var self = this;
        url = await this.decideSortOrder(url);
        if(url.includes(USER_DETAILS["USER_DETAILS"]["rootFolderKey"]) && this.universalService.activeRepo == ActiveRepo.MAIN){
          this.indexDBData = await this.checkDataIndexDB(url)
          if(!this.indexDBData){
            this.universalService.showLoader = true;
            this.getAllFilesObjectsApi(url,this.sortOrder);
          }else{
            this.universalService.showLoader = true;
            if(!this.universalService.listView  || this.universalService.isMobileDevice){ // grid view makes 2 calls, one for folders (limit=1000) and one for files (limit=100)
              if(url.includes('type=w') && !this.universalService.virtualGridEnabled){
                this.resizeableObjectList = this.indexDBData["objects"];
                this.setDataAsPerView(this.indexDBData["objects"],url);
              }else{
                this.storeBufferDataInDBAndRenderOnlyLimitedItems(this.indexDBData,url);
              }
            }else{
              this.storeBufferDataInDBAndRenderOnlyLimitedItems(this.indexDBData,url);
            }
          }
        }else{
          this.universalService.currentOpenIndexDBStoreforFolder =  "";
          this.universalService.currentOpenIndexDBStoreforFile = "";
          this.universalService.showLoader = true;
          this.getAllFilesObjectsApi(url,this.sortOrder);
        }
      }

      getAllFilesObjectsApi(url,sortOrder){
        if(url && url.includes("type=w") && url.includes("type=w") && url.includes("createdDate")) {
          url = url.replace("createdDate","fileCreatedDate")
        }

        this.http.get(url).subscribe(
          suc=>{
            if(url.includes(USER_DETAILS["USER_DETAILS"]["rootFolderKey"])){
              this.saveToIndexDB(url,suc)
            }
            if(!this.universalService.listView  || this.universalService.isMobileDevice){ // grid view makes 2 calls, one for folders (limit=1000) and one for files (limit=100)
              if(url.includes('type=w') && !this.universalService.virtualGridEnabled){
                this.resizeableObjectList = suc["objects"];
                this.setDataAsPerView(suc["objects"],url);
              }else{
                this.storeBufferDataInDBAndRenderOnlyLimitedItems(suc,url);
              }
            }else{
              this.storeBufferDataInDBAndRenderOnlyLimitedItems(suc,url);
            }
            
          },
          err=>{
            this.universalService.disableModalBackdrop();
            if(err["error"]["code"] == 'NMSOM0062'){
              this.universalService.showToast(TOAST["FOLDER_KEY_INVALID"],"error");
              AppEvents.emit(EventsList.MYFILES_TABBED_VIEW);
              this.router.navigate(["/allfiles"]);
              this.universalService.showLoader = false;
            }else{
              this.universalService.showErrorMessage(err);
            }
          }
        )
      }


      storeBufferDataInDBAndRenderOnlyLimitedItems(suc,url){
        this.resizeableObjectList = suc["objects"];
        this.paginationService.spliceAndSaveDataInLocalDB(suc["objects"]);
        this.setNextAndPreviousLinks(suc,url);
        this.setDataAsPerView(this.paginationService.getBufferDataForNextPage(this.currentPageNo),url)
        this.handleNextLinkToGetFilesAfterFolder(url,suc); // to check if next link is not present for folders then make a call to files
        this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
      }


      setNextAndPreviousLinks(suc,url){
        if(suc["nextLink"] && !url.includes('limit=1000')){
          this.allFilesnextLink = suc["nextLink"]
          if (this.allFilesnextLink.includes("sort=")) {
            if (this.allFilesnextLink.includes("sort=+")) {
              this.allFilesnextLink=this.allFilesnextLink.replace("sort=+", "sort=%2B")
            }else if (this.allFilesnextLink.includes("sort=-")) {
              this.allFilesnextLink=this.allFilesnextLink.replace("sort=-", "sort=%2D")
            }
          }else if(this.allFilesnextLink==""){
            this.allFilesnextLink=""
          }
        }else if(!url.includes('limit=1000')){ 
          
          this.allFilesnextLink = ""
        }
        this.universalService.allFilesnextLink = this.allFilesnextLink 
      }

     async setDataAsPerView(objects,url){
      var self = this;
        this.universalService.scrollToTopIcon = false;
        this.universalService.emptyFolder = false;
        this.universalService.showSortButtons = true;
        this.universalService.emptyTrash = false;
        this.universalService.emptyFav = false;
        if(this.universalService.openFolderContent && objects && objects.length==0){
          this.universalService.showLoader = false;
          this.universalService.emptyFolder = true;
          this.universalService.showSortButtons = false;
        }else if(objects && objects.length==0 && this.universalService.foldersArray.length == 0 && url.includes("type=f")){ 
          this.universalService.showLoader = false;
          this.universalService.emptyFolder = true;
          this.universalService.showSortButtons = false;
        }else{
          this.universalService.showSortButtons = true;
        }

        if(objects && objects.length == 0 && this.universalService.activeRepo == 'share'){ // share has a different graphic there are no shared files
        this.universalService.emptyFolder = true;
        }
        
        this.listService.getPPFToken();
        var allData = this.customMetadata.segregateData(objects,'allfiles');      
        if(allData.length==0 && url.includes("type=f") ){
          this.universalService.emptyTab = true;
        }else{
          this.universalService.emptyTab = false;
        }
        if(this.universalService.listView && !this.universalService.isMobileDevice){
            if(this.universalService.objectsPreviewArray.length == 0){
              this.universalService.foldersArray = allData
            }
            this.allfileslistsize = this.allfileslistsize + allData.length;
            setTimeout(() => {
              let tab = "allfiles";
              if(this.listService.listOptions.api && this.listService.listOptions.api["columnModel"]) {
                this.listImpl.decideListOptions(tab);
                this.listImpl.setRowDataForList(allData);  
              }
            }, 100);
        }else{
            let parentId="#allFilesWrapperId"
            if( this.router.url.includes("privatefolder"))
              parentId="#privateFolderWrapperId"
            if(this.refetchData == true){
              this.universalService.sortByNameArray = [];
              this.universalService.sortByDateArray = [];
              this.universalService.foldersArray = [];
              this.refetchData = false;
            }

            if(this.universalService.foldersArray.length != 0 || this.universalService.sortByNameArray.length != 0 || this.universalService.sortByDateArray.length != 0 ){
              this.universalService.emptyFolder = false;
            }
            if(this.universalService.nameSort){
              let sortingOrder = "asc";
              if(url.includes("%2D"))
                sortingOrder = "desc";
              setTimeout(() => {
                this.sortByName(allData,sortingOrder);
              }, 10);
              if(this.universalService.showJustifiedLayout){
                this.decideOnJustifiedView(true,parentId);
              }
            }else {
              setTimeout(() => {
                this.sortByDate(allData);
              },10);
              if(this.universalService.showJustifiedLayout){
                this.decideOnJustifiedView(false,parentId);
              }
            }
            this.bindMultiSelect();
        }
        if(this.universalService.openFolderContent && this.universalService.listView && !this.universalService.isMobileDevice)
            this.universalService.selectedNodes = [];

        // if(this.universalService.activeRepo == ActiveRepo.SHARE){
        //   this.foldersViewImpl.folderShownCount = this.universalService.foldersArray.length;
        // }

        if(this.universalService.firstTimeHit  && objects.length == 1 && objects[0].objectType != 'FR'){
          this.universalService.firstTimeHit = false;
          if(this.universalService.activeRepo == 'share'){
            var el = document.getElementById("libLeftMenu");
            if(el!=null){
              el.style.opacity = '0';
              setTimeout(()=>{el.style.opacity = '1'}, 800);
            }
          }
          this.universalService.openPreview(objects[0]);
        }else if(this.universalService.firstTimeHit && this.rootFolderCheck && objects.length == 1 && objects[0].objectType == 'FR'){
          this.universalService.selectedFile = objects[0];
          this.universalService.openFolderContent = true;
          this.universalService.insideFolder = true;
          setTimeout(()=>{
            this.universalService.showTopMenu = false;
            this.universalService.hideTopMenuOptions();  
          },100)
          
        }
        else if(this.universalService.firstTimeHit && this.universalService.isUnivSharelink && objects.length == 1 && objects[0].objectType == 'FR'){
          this.universalService.firstTimeHit = false;
          this.universalService.foldersArray = [];
          this.universalService.sortByDateArray = [];
          this.universalService.sortByNameArray = [];
          setTimeout(() => {
            this.universalService.selectedFile = objects[0];
            this.universalService.openFolderContent = true;
            this.universalService.insideFolder = true;
          }, 100);
        }
        else if(this.universalService.firstTimeHit){
          this.universalService.firstTimeHit = false;
        }
        this.setHeightForView();
      }


      decideOnJustifiedView(sortbyName,parentId){ 
        if(sortbyName){
          var justifiedView = this.JsView.generateJustifiedView(this.universalService.sortByNameArray,parentId,this.universalService.rowHeightTolerance)
          this.universalService.sortByNameArray = justifiedView
          AppEvents.multiSelectEvent.next({"dataArray":this.universalService.sortByNameArray.concat(this.universalService.foldersArray)})
        } else{
          var justifiedView = this.JsView.generateJustifiedView(this.universalService.sortByDateArray,parentId,this.universalService.rowHeightTolerance)
          this.universalService.sortByDateArray = justifiedView
          AppEvents.multiSelectEvent.next({"dataArray":this.universalService.sortByDateArray.concat(this.universalService.foldersArray)})
        }
        
      }


      sortByDate(allFiles) {
        var sortParam = localStorage.sharePublicSort.includes("fileCreatedDate")? "createdDate" : "uploaded";
        var array  = this.customSort.sortByDates(allFiles,this.universalService.sortByDateArray,this.universalService.sharedRoot,sortParam);//"createdDate"
        this.universalService.sortByDateArray = array[0];
        this.universalService.objectsPreviewArray = array[1];
        this.universalService.loadGridView = true;
        if(this.universalService.sortByDateArray.length == 0 && this.universalService.foldersArray.length == 0){
          this.universalService.emptyTab = true;
          this.universalService.showLoader = false;
          AppEvents.virtualDOMObservable.next({"updateVDOM":true})
          return
        }else{
          this.universalService.emptyTab = false;
          this.universalService.emptyFolder = false;
          this.universalService.showSortButtons = true;
        }
        setTimeout(() => {
          this.universalService.showLoader = false;  
        }, 10);
        if(this.universalService.activeRepo == ActiveRepo.SHARE) {
          this.foldersViewImpl.folderShownCount = this.universalService.foldersArray.length;  
        } else if (this.universalService.activeRepo == ActiveRepo.MAIN && this.foldersViewImpl.folderShownCount > this.deskFoldersCount && !this.universalService.isMobileDevice && (this.universalService.foldersArray && this.universalService.foldersArray.length > 0)) { //If on desktop, user is in 'see all' mode, add new folders to view on copy scenario - 690834
          this.foldersViewImpl.folderShownCount = this.universalService.foldersArray.length;  
        }
        AppEvents.virtualDOMObservable.next({"updateVDOM":true});
        AppEvents.multiSelectEvent.next({"dataArray":this.universalService.sortByDateArray.concat(this.universalService.foldersArray)})
      }



      sortByName(allFiles,sortingOrder){
        var array  = this.customSort.sortByNames(allFiles,this.universalService.sortByNameArray,sortingOrder);
        this.universalService.sortByNameArray = array[0];
        this.universalService.objectsPreviewArray = array[1];
        this.universalService.loadGridView = true;
        if(this.universalService.sortByNameArray.length == 0 && this.universalService.foldersArray.length == 0){
          this.loggerService.log("inside empty all files",this.universalService.sortByNameArray)
          this.universalService.emptyTab = true;
          this.universalService.showLoader = false;
          AppEvents.virtualDOMObservable.next({"updateVDOM":true})
          return
        }else{
          this.universalService.emptyTab = false;
          this.universalService.emptyFolder = false;
          this.universalService.showSortButtons = true;
        }
        setTimeout(() => {
          this.universalService.showLoader = false;  
          if(this.universalService.isViewFileClicked == true) {
            this.universalService.isViewFileClicked == false;
            document.getElementsByClassName('list_info')[0].scrollIntoView();
          }
        }, 10);
        
        if(this.universalService.activeRepo == ActiveRepo.SHARE) {
          this.foldersViewImpl.folderShownCount = this.universalService.foldersArray.length;
        } else if (this.universalService.activeRepo == ActiveRepo.MAIN && this.foldersViewImpl.folderShownCount > this.deskFoldersCount && !this.universalService.isMobileDevice && (this.universalService.foldersArray && this.universalService.foldersArray.length > 0)) { //If on desktop, user is in 'see all' mode, add new folders to view on copy scenario - 690834
          this.foldersViewImpl.folderShownCount = this.universalService.foldersArray.length;
        }
        AppEvents.virtualDOMObservable.next({"updateVDOM":true});
        AppEvents.multiSelectEvent.next({"dataArray":this.universalService.sortByNameArray.concat(this.universalService.foldersArray)})
      }
    
      dynamicSort(key) {
        return function (a,b) {
          return a[key].localeCompare(b[key]);   
        }
      }

      bindMultiSelect(){
        this.multiSelect = MultiSelectLibrary.getInstance(this.globalService);
        if(this.universalService.listView && (this.universalService.currentTab == 'allfiles') && this.universalService.isMobileDevice) {
          this.multiSelect.bindMultiSelectLibrary("#AllFilesWrapperId", "list_info", ".listItem:visible", false,this.universalService.virtualGridEnabled,false);
          this.multiSelect.bindMultiSelectUIevent(".main-wrapper", ".list_file_child");
        }else if(this.universalService.listView && this.universalService.currentTab == 'PrivateFolder' && this.universalService.isMobileDevice) {
          this.multiSelect.bindMultiSelectLibrary("#privateFolderWrapperId", "list_info", ".listItem:visible", false,this.universalService.virtualGridEnabled,false);
          this.multiSelect.bindMultiSelectUIevent(".main-wrapper", ".list_file_child");
        } else {
          setTimeout(() => {  
            this.multiSelect.bindMultiSelectLibrary(".allFilesWrapper", "grid_info", ".gridItem:visible", true,this.universalService.virtualGridEnabled,false);
            this.multiSelect.bindMultiSelectUIevent(".tab-content", ".grid_file_child");  
          }, 100);
        }
      }




      createUrlForNextLink(docheight,toppos,url,containerName){
          if(toppos == 0){
            this.universalService.scrollToTopIcon = false;
          }else{
            this.universalService.scrollToTopIcon = true;
            let sortingOrder = "asc";
            if(url.includes("%2D")){
              sortingOrder = "desc";
            }
            let checkIfContaineris95PercScrolled = this.universalService.virtualGridEnabled ? true : ($('.allFilesScrollableContainer').scrollTop() + $(containerName).innerHeight()) >= (0.95 * docheight)
            if(checkIfContaineris95PercScrolled && this.previousPageNo != this.currentPageNo && this.paginationService.LOCAL_DB[this.currentPageNo + 1] && this.paginationService.LOCAL_DB[this.currentPageNo + 1].length != 0){
              this.previousPageNo = this.currentPageNo;
              setTimeout(async () => { // timeout is added to restrict fetching data for multiple pages back to back as the scroll event is fired multiple times
                this.currentPageNo ++;
                let objList = await this.paginationService.getBufferDataForNextPage(this.currentPageNo);
                await this.appendData(objList,sortingOrder);
                this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
              }, this.paginationService.bufferTimeoutForFetchingData);
            }

            if(checkIfContaineris95PercScrolled && this.allFilesnextLink != "" && this.allFilespreviousLink != this.allFilesnextLink){
              this.allFilespreviousLink = this.allFilesnextLink;
              this.universalService.showLoader = true;
              this.getNextPageData(url,sortingOrder);
            }
          }
      }

    createUrlForNextLinkOnDesktop(url) {
      if (this.listService.listOptions.api.getVerticalPixelRange().top == 0)
        this.universalService.scrollToTopIcon = false;
      else
        this.universalService.scrollToTopIcon = true;
      let sortingOrder = "asc";
      if(url.includes("%2D")){
        sortingOrder = "desc";
      }
      if(this.allfileslistsize - this.listService.listOptions.api.getLastDisplayedRow() < 3 && this.previousPageNo != this.currentPageNo && this.paginationService.LOCAL_DB[this.currentPageNo + 1] && this.paginationService.LOCAL_DB[this.currentPageNo + 1].length != 0){
        this.previousPageNo = this.currentPageNo;
        setTimeout(async () => { // timeout is added to restrict fetching data for multiple pages back to back as the scroll event is fired multiple times
          this.currentPageNo ++;
          let objList = await this.paginationService.getBufferDataForNextPage(this.currentPageNo);
          await this.appendData(objList,sortingOrder);
          this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
        }, this.paginationService.bufferTimeoutForFetchingData);
      }

      if (this.allfileslistsize - this.listService.listOptions.api.getLastDisplayedRow() < 3) {
        if ((this.allFilespreviousLink != this.allFilesnextLink)) {
          this.allFilespreviousLink = this.allFilesnextLink
          if (this.allFilesnextLink != "") {
            this.universalService.showLoader = true;
            this.getNextPageData(url,sortingOrder);
          }
        }
      }        
    }

    getNextPageData(url,sortingOrder,firstfilescall=false){
      var self = this;
      return new Promise(function(resolve,reject){
        self.http.get(url).subscribe(
            async nextPageData=>{
              if(url.toLowerCase().indexOf("page") === -1 && url.includes(USER_DETAILS["USER_DETAILS"]["rootFolderKey"])){
                self.saveToIndexDB(url,nextPageData)
              }
              await self.pageDataHandling(url,sortingOrder,nextPageData,firstfilescall)
              self.universalService.showLoader = false;
              resolve(true);
            },
            err=>{
              self.universalService.showErrorMessage(err);
              self.universalService.showLoader = false;
              reject(err)
            }
          )
      })
    }

    pageDataHandling(url,sortingOrder,nextPageData,firstfilescall=false){
      var self = this;
      return new Promise(async function(resolve,reject){
            
              if(nextPageData["objects"] && (firstfilescall || !self.paginationService.LOCAL_DB[self.currentPageNo])){ // this condition is added when user has scrolled all the buffer data, there is no buffer data left and API call is taking time or due to network latency to return data, post API response we are populating the data
                let bufferDataPresent = self.paginationService.checkIfBufferDataIsPresent();
                if(!bufferDataPresent){
                  self.currentPageNo = Object.keys(self.paginationService.LOCAL_DB).length;
                  self.previousPageNo = self.currentPageNo - 1;
                  self.paginationService.spliceAndSaveDataInLocalDB(nextPageData["objects"]);
                  self.setNextAndPreviousLinks(nextPageData,url);
                  self.handleNextLinkToGetFilesAfterFolder(url, nextPageData)
                  let objList = await self.paginationService.getBufferDataForNextPage(self.currentPageNo);
                  setTimeout(() => {
                    if(!self.universalService.listView || self.universalService.isMobileDevice || self.listService.listOptions.api.getDisplayedRowCount() > 0){
                      self.appendData(objList,sortingOrder);
                    }else{
                      self.setDataAsPerView(objList,url)
                    }
                    self.paginationService.deleteLocalBufferOnceThePageIsViewed(self.currentPageNo);
                    resolve({"resp":nextPageData});
                  }, 100);
                  return;
                }
              }
              self.paginationService.spliceAndSaveDataInLocalDB(nextPageData["objects"]);
              self.setNextAndPreviousLinks(nextPageData,url);
              self.handleNextLinkToGetFilesAfterFolder(url, nextPageData)
              resolve(true);
           
      })
    }

    async appendData(objectList,sortingOrder){
      this.resizeableObjectList = this.resizeableObjectList.concat(objectList);
      if(objectList!=undefined && objectList.length>0 && this.universalService.emptyTab && !this.universalService.openFolderContent){
        this.universalService.emptyTab = false;
      }else if(objectList!=undefined && objectList.length>0 && this.universalService.emptyFolder && this.universalService.openFolderContent){
        this.universalService.emptyFolder = false;
      }
      this.listService.getPPFToken();
      this.universalService.allFilesnextLink  = this.allFilesnextLink
      var allData = await this.customMetadata.segregateData(objectList,'allfiles');
      if(this.universalService.listView && !this.universalService.isMobileDevice){
        this.allfileslistsize = this.allfileslistsize + allData.length;
        this.listImpl.appendRowDataForList(allData);
      }else{
        let parentId="#allFilesWrapperId"
        if( this.router.url.includes("privatefolder"))
          parentId="#privateFolderWrapperId"
        if(this.universalService.nameSort){
          this.sortByName(allData,sortingOrder);
          if(this.universalService.showJustifiedLayout){
            this.decideOnJustifiedView(true,parentId);
          }
        }else{
          this.sortByDate(allData)
          if(this.universalService.showJustifiedLayout){
            this.decideOnJustifiedView(false,parentId);
          }
        }
      }   
    }

  async handleNextLinkToGetFilesAfterFolder(url,resp) {
    var filesUrl = "";
    if((this.universalService.currentTab == "PrivateFolder")){
      return;
    }
    //If allFilesnextLink is "", and previous call happened for folder type, next fetch files type
    //added limit check, as if user has > 1000 objects, it was showing nextLink and  has limit of 1000 objects as of now (keep consistent with Grid view, if in future grid limit is removed, just need to remove limit check here and other places as well)!
    if(resp && (resp["nextLink"] == "" || resp["nextLink"] == undefined || resp["nextLink"].includes("limit=1000")) && url.includes("type=w")) {
      var type = 'f';
      let limit:number =  ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"];
      const currentFolderKey = this.sessionStorageSvc.getCurrentFolderkey(true);          
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + ENV_CONFIG.commonUrls["nmsMetadataDefaultviewMyfiles"] + "?limit="+ limit  + "&folderKey=";
      if (currentFolderKey) {
        url = type ?  url + currentFolderKey + "&type=" + type : url + currentFolderKey;
        this.rootFolderCheck = false;
      } else {
        url = type ?  url + USER_DETAILS["USER_DETAILS"]["rootFolderKey"] + "&type=" + type : url + USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
        this.rootFolderCheck = true;
      }
      if(!this.universalService.listView || (this.universalService.listView && this.universalService.isMobileDevice)) {
        this.sortOrder='&sort='+localStorage.sharePublicSort;
      }
      url   = url + this.sortOrder;
      let sortingOrder = "asc";
      if(url.includes("%2D")){
        sortingOrder = "desc";
      }
      this.indexDBData = await this.checkDataIndexDB(url)
      if(!this.indexDBData){
        this.universalService.showLoader = true;
        this.getNextPageData(url,sortingOrder,true);
      }else{
        await this.pageDataHandling(url,sortingOrder,this.indexDBData,true)
      }

     
    }
  }

  openFolder(folder, moduleMetadata:any = {}) {
    this.universalService.scrollToTopIcon = false;
    this.listService.cellclick = false;
    if(this.universalService.activeRepo == 'main'){
      if(moduleMetadata.moduleType) { //This will hold feature like jiophone call ai, provate folder, my files likewise.
        this.router.navigate([moduleMetadata.route, folder.objectKey]);  
      } else {
        this.router.navigate(['/allfiles', folder.objectKey]);
      }
    }
    if(this.universalService.mobileSelectionModeOn){
      this.universalService.switchOffMobileSelectionMode();
    }
    this.sessionStorageSvc.setCurrentFolderKey(folder.objectKey, true)

    this.universalService.isServerError = false;
    if (folder.parentObjectName == ( moduleMetadata &&  moduleMetadata?.parentObjectName ? moduleMetadata?.parentObjectName :'Root Folder') || this.globalService.getFolderServiceRef().breadCrumbsList.length == 1) {
      this.universalService.selectedFile = folder;
      this.globalService.getFolderServiceRef().manageBreadCrumbs(folder.objectKey, folder.objectName, folder);
      this.universalService.openFolderContent = true;
      this.universalService.insideFolder = true;
      setTimeout(() => {
        this.universalService.showTopMenu = false;
        this.universalService.hideTopMenuOptions();  
      }, 100)
      return true;
    } else {
      this.universalService.selectedFile = folder;
      this.universalService.showTopMenu = false;
      this.universalService.hideTopMenuOptions();  
      this.universalService.openFolderContent = true;
      this.universalService.insideFolder = true;
      if(window.location.href.includes('?u') && this.globalService.getFolderServiceRef().breadCrumbsList.length > 1 && this.globalService.getFolderServiceRef().breadCrumbsList[this.globalService.getFolderServiceRef().breadCrumbsList.length - 1]["objectKey"] != folder["objectKey"]){
        AppEvents.globalObservable.next({"open":true,"object":folder});
      }
      this.globalService.getFolderServiceRef().clickedFolderName = folder.objectName;
      this.globalService.getFolderServiceRef().manageBreadCrumbs(folder.objectKey, folder.objectName, folder);
      this.universalService.foldersArray = [];
      return true;
    }  


  }

  updateAllFilesData(obj) {
    let parentId="#allFilesWrapperId"
    if( this.router.url.includes("privatefolder"))
      parentId="#privateFolderWrapperId"
    var self = this;
    var sharedFolderDetails = this.localStorageSvc.getSharedFolder(true);
    if(sharedFolderDetails != undefined && sharedFolderDetails.shareKey != undefined) {
      obj["recipientsObjRights"] = self.universalService.recipientsObjRights;
      obj["shareKey"] = sharedFolderDetails.shareKey;
      obj["isShared"] = true;
    }
    var currentFolderKey = this.sessionStorageSvc.getCurrentFolderkey(true);
    currentFolderKey = currentFolderKey == ""? USER_DETAILS["USER_DETAILS"]["rootFolderKey"]:currentFolderKey;
    if(obj.objectType == 'FR' && obj["parentObjectKey"] == currentFolderKey){
      this.universalService.totalCountOfFolders++; 
    }
    
    let objectsList = [];
    this.listService.getPPFToken();
    objectsList.push(obj);
    let response = this.customMetadata.segregateData(objectsList, 'allfiles');
    this.universalService.showSortButtons = true;
    if (this.universalService.nameSort) {
      let sortingOrder = localStorage.sharePublicSort.includes("%2D")?"desc":"asc";
      let sortedData = this.customSort.sortByNames(response, this.universalService.sortByNameArray,sortingOrder,true);
      this.universalService.sortByNameArray = sortedData[0];
      if (this.universalService.showJustifiedLayout && obj["format"] == 'image'){
        this.universalService.sortByNameArray = this.JsView.generateJustifiedView(this.universalService.sortByNameArray, parentId, this.universalService.rowHeightTolerance);
      }else{
        if(this.universalService.showJustifiedLayout){
          this.universalService.showJustifiedLayout = false;
          this.bindMultiSelect();
        }
      }
      AppEvents.virtualDOMObservable.next({"updateVDOM":true,"action":"upload",'object':obj,"uploadDetails":sortedData[2],sortType:'name','foldersArray':this.universalService.foldersArray,'sortedArray':this.universalService.sortByNameArray})
      AppEvents.multiSelectEvent.next({"dataArray":this.universalService.sortByNameArray})
    } else {
      let sortedData = this.customSort.sortByDates(response, this.universalService.sortByDateArray, this.universalService.sharedRoot, "createdDate",true);
      this.universalService.sortByDateArray = sortedData[0];
      if (this.universalService.showJustifiedLayout && obj["format"] == 'image'){
        this.universalService.sortByDateArray = this.JsView.generateJustifiedView(this.universalService.sortByDateArray, parentId, this.universalService.rowHeightTolerance);
      }else{
        if(this.universalService.showJustifiedLayout){
          this.universalService.showJustifiedLayout = false;
          this.bindMultiSelect();
        }
      }
      AppEvents.virtualDOMObservable.next({"updateVDOM":true,"action":"upload",'object':obj,"uploadDetails":sortedData[2],sortType:'date','foldersArray':this.universalService.foldersArray,'sortedArray':this.universalService.sortByDateArray})
      AppEvents.multiSelectEvent.next({"dataArray":this.universalService.sortByDateArray})
    }
    this.universalService.emptyTab = false;
    this.universalService.emptyFolder = false;
    this.universalService.showSortButtons = true;
  }


  updateListView(obj){
  var self = this;
  var sharedFolderDetails = this.localStorageSvc.getSharedFolder(true);
  if(sharedFolderDetails != undefined && sharedFolderDetails.shareKey != undefined) {
    obj["recipientsObjRights"] = self.universalService.recipientsObjRights;
    obj["shareKey"] = sharedFolderDetails.shareKey;
    obj["isShared"] = true;
  }
  let objArray = [obj];
  this.universalService.emptyTab = false;
  this.universalService.emptyFolder = false;
  this.universalService.showSortButtons = true;
  setTimeout(() => {
    this.listImpl.updateListViewData(objArray);
  }, 100);
  }
  
  selectAll(event){
    this.listImpl.selectAll(event)
  }

  setHeightForView(){
    var self = this;
    this.setHeightForContainer();
    $(window).resize(function () {
      self.setHeightForContainer();
    });
  }

  setHeightForContainer(){
    var self = this;
    var collapsedHeight = $('#m-collapsed-modal .modal-content').height();
    collapsedHeight = collapsedHeight?collapsedHeight:0
    if (!self.universalService.isMobileDevice) {
       setTimeout(() => {
        if(self.universalService.listView && !this.universalService.emptyFolder){
          self.containerHeightCalc.calculateHeight('.tab-content #ag-grid',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'], 49)
          jQuery('.allFilesScrollableContainer').height("auto");
        }else{
          if(this.universalService.virtualGridEnabled) return;
          self.containerHeightCalc.calculateHeight('.allFilesScrollableContainer',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'], 49);
        }
       }, 500); 
     }else{
      if(this.universalService.virtualGridEnabled) return;
      setTimeout(() => {
        self.containerHeightCalc.calculateHeight('.allFilesScrollableContainer',['.pseudo-mobile-header','.pseudo-tab','.pseudo-banner-container','.pseudo-audiominiplayer'],(65 + collapsedHeight))
      },500);
    }
  }


  async getAllFoldersData(url) {
    var self = this;
    this.indexDBData = await this.checkDataIndexDB(url)
    if (!this.indexDBData) {
      self.universalService.showLoader = true;
      return new Promise(function (resolve, reject) {
        self.http.get(url).subscribe(
          suc => {
            if (url.includes(USER_DETAILS["USER_DETAILS"]["rootFolderKey"]))
              self.saveToIndexDB(url, suc)
            self.universalService.showLoader = false;
        
            resolve(suc.objects);
          },
          error => {
            self.universalService.showLoader = false;
            if (error.status! = 403) {
              console.log("error in getting getAllFoldersData .", error);
              self.universalService.showErrorMessage(error);
              self.universalService.isServerError = false;
              reject(error);
            }
          },
        )
      });
    } else {
      return this.indexDBData;

    }
  }

  getObjectMetadata(metadataURL){
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.get(metadataURL).subscribe(
          info=>{
                resolve(info)
          },
          err=>{
                console.log('obj metadata err',err);
                reject(err)
          }
        )
    })
  }
    


  initializeAgGridForIfUploadedInEmptyView(){
    this.listImpl.initializeAgGridForIfUploadedInEmptyView('allfiles');
  }
    
  
  

 


  }